import React from "react";
import { Car } from "lucide-react";
import About1 from "../assets/images/about-1.jpg";
import About2 from "../assets/images/about-2.jpg";

const AboutUs = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="about" className="bg-white" aria-labelledby="about-heading">
      {/* Hero Section */}
      <div className="relative overflow-hidden bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Text Content */}
            <div className="space-y-8">
              <header>
                <h2
                  id="about-heading"
                  className="text-3xl md:text-4xl font-bold text-center mb-4"
                >
                  About Us
                </h2>
              </header>

              <p className="text-gray-600 text-lg leading-relaxed">
                Elam Travels in Trichy is your trusted partner for car rentals,
                outstation taxi services, and luxury car hires, all customized
                to meet your travel needs. We pride ourselves on delivering
                exceptional service at affordable prices, ensuring every journey
                is comfortable and unforgettable.
              </p>

              <p className="text-gray-600 text-lg leading-relaxed">
                Our fleet includes budget-friendly options like Maruti Swift
                Dzire, Toyota Etios, and Toyota Innova Crysta, catering to a
                wide range of preferences. With well-maintained vehicles and
                experienced drivers dedicated to your safety and convenience,
                we've become a leading name in Trichy's travel industry. Let us
                make your trips smooth, enjoyable, and hassle-free.
              </p>

              <button
                className="bg-orange-400 hover:bg-orange-500 text-black px-8 py-3 rounded-full font-medium transition-colors duration-200"
                onClick={() => scrollToSection("contact")}
                aria-label="Enquire Now"
              >
                Enquire Now
              </button>
            </div>

            {/* Image Gallery */}
            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                <div className="relative h-64 overflow-hidden rounded-xl transform rotate-2">
                  <img
                    src={About1}
                    alt="Taxi service with well-maintained vehicles"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="relative h-64 overflow-hidden rounded-xl transform -rotate-2 mt-8">
                  <img
                    src={About2}
                    alt="Luxury car available for hire"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
